(function () {
var $4e43151c03b66ea5$exports = {};
const $4e43151c03b66ea5$var$mail = document.body.querySelector("#about #mail");
const $4e43151c03b66ea5$var$email = document.createElement("a");
const $4e43151c03b66ea5$var$decoded = atob("bWFpbHRvOk1hSWwuU2hSRXlBZ0BHbUFpTC5jT20=");
$4e43151c03b66ea5$var$email.textContent = $4e43151c03b66ea5$var$decoded.substring(7);
//email.href = decoded.toLowerCase().replace('@', '+website@');
$4e43151c03b66ea5$var$email.title = "Send E-mail";
$4e43151c03b66ea5$var$email.rel = "foaf:mbox";
$4e43151c03b66ea5$var$mail.prepend($4e43151c03b66ea5$var$email);

})();
//# sourceMappingURL=email.7d6877de.js.map
